module.exports = __webpack_public_path__ + "static/media/welcome-to-dong-my.254e01a0.png";